import { useQuery } from '@apollo/client'
import { ErrorMessage } from 'formik'
import gql from 'graphql-tag'
import get from 'lodash.get'
import * as React from 'react'
import { Form, Input } from 'ui'

interface ISchoolDistrictDataShape {
  [key: string]: string
  id: string
  name: string
}

interface ISchoolDistrictQueryData {
  response: {
    district: ISchoolDistrictDataShape | null
    districts: ISchoolDistrictDataShape[] | null
    lastEvaluatedKey: string | null
    pageSize: number | null
    success: boolean
    errors: Array<{ path: string; message: string }> | null
  }
}

const DISTRICTS_QUERY = gql`
  query Districts {
    response: districts {
      districts {
        id
        name
      }
      success
      pageSize
    }
  }
`

export type DistrictSelectFn = (district: ISchoolDistrictDataShape) => void

interface IDistrictSelectProps {
  name: string
  label: string
  value: string
  onDismiss: () => void
  onSelect: DistrictSelectFn
  placeholder: string
  disabled?: boolean
  required?: boolean
}

export const DistrictSelectField: React.FunctionComponent<
  IDistrictSelectProps
> = (props) => {
  const { data, loading, networkStatus } =
    useQuery<ISchoolDistrictQueryData>(DISTRICTS_QUERY)
  const districts =
    (get(data, 'response.districts') as ISchoolDistrictDataShape[]) || null
  return (
    <Input.FieldContainer disabled={props.disabled}>
      <Form.Label>
        {props.label} {props.required ? <Form.RequiredIcon /> : null}
      </Form.Label>
      <Input.Dropdown
        value={props.value}
        placeholder={props.placeholder}
        onDismiss={props.onDismiss}
        pushContent={true}
        loading={loading || networkStatus === 4}
      >
        {(searchValue, dismiss) => (
          <React.Fragment>
            {!districts
              ? null
              : districts
                  .filter(
                    (district) =>
                      district.name
                        .toLowerCase()
                        .indexOf(searchValue.toLowerCase()) > -1
                  )
                  .map((district) => {
                    const onClick: React.MouseEventHandler = (e) => {
                      e.stopPropagation()
                      props.onSelect(district)
                      dismiss()
                    }
                    return (
                      <Input.AutocompleteSuggestion
                        key={`${props.name}DistrictSearchResult${district.id}`}
                        displayName={
                          <Input.SuggestionDetailView heading={district.name} />
                        }
                        onClick={onClick}
                      />
                    )
                  })}
          </React.Fragment>
        )}
      </Input.Dropdown>
      <ErrorMessage name={props.name} component={Input.Error} />
    </Input.FieldContainer>
  )
}
